import { pushDataTrackerEvent } from 'approot/shared/data-tracker/data-tracker-push';
import {
  EVENT_CATEGORY_CONTENT,
  EVENT_ACTION_REMOVE_COMPLETE,
  EVENT_ACTION_FOLLOW,
  EVENT_TARGET_TYPE_MODAL,
  EVENT_TARGET_IDENTIFIER_CONTENT_REMOVE_COMPLETE,
  EVENT_TARGET_IDENTIFIER_CONTENT_EDIT_COMPLETE,
  EVENT_ACTION_EDIT_COMPLETE,
  EVENT_ACTION_COMPLETE,
} from 'approot/shared/data-tracker/data-events.constants';
import { ASSESSMENT, LESSON } from 'global/constants';
import type { UpdateAssessmentInPlannerMutation } from './complete.graphql.generated';
import type { UpdateLessonInPlannerMutation } from './complete.graphql.generated';
import type { Pluck } from 'lib/gql/pluck';

export function pushInCompleteEvent(
  isLesson: boolean,
  contentId: number,
  completeId: number
) {
  pushDataTrackerEvent(EVENT_CATEGORY_CONTENT, EVENT_ACTION_REMOVE_COMPLETE, {
    target_type: isLesson ? LESSON : ASSESSMENT,
    target_identifier: contentId,
    complete_id: completeId,
  });
}

export function pushRemoveCompleteFollow() {
  pushDataTrackerEvent(EVENT_CATEGORY_CONTENT, EVENT_ACTION_FOLLOW, {
    target_type: EVENT_TARGET_TYPE_MODAL,
    target_identifier: EVENT_TARGET_IDENTIFIER_CONTENT_REMOVE_COMPLETE,
  });
}

export function pushEditCompleteFollow() {
  pushDataTrackerEvent(EVENT_CATEGORY_CONTENT, EVENT_ACTION_FOLLOW, {
    target_type: EVENT_TARGET_TYPE_MODAL,
    target_identifier: EVENT_TARGET_IDENTIFIER_CONTENT_EDIT_COMPLETE,
  });
}

export function pushCompleteEvent(
  isLesson: boolean,
  contentId: number,
  completeId: number,
  startDate: Date,
  endDate: Date
) {
  pushDataTrackerEvent(EVENT_CATEGORY_CONTENT, EVENT_ACTION_COMPLETE, {
    target_type: isLesson ? LESSON : ASSESSMENT,
    target_identifier: contentId,
    complete_id: completeId,
    started_at: startDate,
    completed_at: endDate,
  });
}

export function pushEditCompleteEvent(
  isLesson: boolean,
  contentId: number,
  completeId: number,
  startDate: Date,
  endDate: Date
) {
  pushDataTrackerEvent(EVENT_CATEGORY_CONTENT, EVENT_ACTION_EDIT_COMPLETE, {
    target_type: isLesson ? LESSON : ASSESSMENT,
    target_identifier: contentId,
    started_at: startDate,
    completed_at: endDate,
    complete_id: completeId,
  });
}

export function getPlannerItems(
  item:
    | Pluck<
        UpdateAssessmentInPlannerMutation,
        'updateAssessmentInPlanner.assessment'
      >
    | Pluck<UpdateLessonInPlannerMutation, 'updateLessonInPlanner.lesson'>,
  plannerId: number,
  unitId: number
) {
  if (item.integratedUnit?.id === unitId) {
    return item.integratedUnit.unitPlannersInfo.find(
      p => p.plannerId === plannerId
    )?.plannerItems;
  } else {
    return item.unit.unitPlannersInfo.find(p => p.plannerId === plannerId)
      ?.plannerItems;
  }
}
